import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { withApollo } from 'react-apollo';
import { Modal, Spinner } from 'vtex.styleguide';
import SimpleReactValidator from 'simple-react-validator';
import queryGiftCard from '../../graphql/queries/queryGiftCard.gql';
import Helpers from '../../helpers/Helpers';

class ModalGiftCardBalance extends Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 'form',
            errorMessage: '',
            balance: '',
            isLoading: false,
            formFields: {
                number: '',
                code: '' 
            }
        }

        this.validator = new SimpleReactValidator();
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentDidUpdate() {
        const modalElement = ReactDOM.findDOMNode(this.refs.modalGiftCardBalance);

        if(modalElement) {
            modalElement.classList.add('vtex-modal__overlay--gift--card--balance');
            modalElement.classList.add('vtex-modal__overlay--mobile--full');
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        
        let formFields = Object.assign({}, this.state.formFields);
        formFields[name] = value;

        this.setState({ formFields });
    }

    handleSubmit(e) {
        e.preventDefault();

        const { number, code } = this.state.formFields;

        if (this.validator.allValid()) {
                
            this.setState({ isLoading: true });

            const variables = {
                number: Helpers.getOnlyNumbers(number.trim()),
                code: code.trim()
            }

            this.props.client.query({
                query: queryGiftCard,
                variables
            })
            .then(res => {
                const { giftCard } = res.data;

                if (giftCard.balance === null) {
                    this.showErrorMessage('Cartão Presente não encontrado.');
                    return false;
                }
                
                if (
                    giftCard.expiringDate &&
                    new Date().getTime() > new Date(giftCard.expiringDate).getTime() 
                ) {
                    this.showErrorMessage('Cartão Presente expirado.');
                    return false;
                }

                this.setState({ 
                    step: 'balance',
                    balance: giftCard.balance,
                    isLoading: false
                });
            })
            .catch(e => {
                this.showErrorMessage('Cartão Presente não encontrado.');
                console.log(e);
            });
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.forceUpdate();
        }
    }

    showErrorMessage(errorMessage) {
        this.setState({
            errorMessage,
            isLoading: false
        })
    }

    onClose() {
        this.resetState();
        this.props.onClose();
    }

    resetState() {
        this.setState({
            step: 'form',
            errorMessage: '',
            balance: '',
            isLoading: false,
            formFields: {
                number: '',
                code: '' 
            }
        });
    }

    renderForm() {
        const { isLoading, errorMessage } = this.state;

        return (
            <form className="default-form no-background" onSubmit={this.handleSubmit}>

                <div className="fields-row margin-bottom form__controls">
                    <div className="form__controls field-control-100  field-control-full-line">
                        <label htmlFor="giftCardNumber" className="label-block">
                            Qual o número do seu cartão presente?
                        </label>
                        <InputMask
                            mask="999 - 999 - 999"
                            maskChar={''}
                            type="text"
                            className="field"
                            id="giftCardNumber"
                            name="number"
                            placeholder="EX: 123 - 456 - 789"
                            value={this.state.formFields.number}
                            onChange={this.handleInputChange}
                        />
                        {this.validator.message('number', this.state.formFields.number, 'required', 'text-danger', { default: 'Preencha o Número do cartão' })}
                    </div>
                </div>

                <div className="fields-row margin-bottom form__controls">
                    <div className="form__controls field-control-100 field-control-full-line">
                        <label htmlFor="giftCardCode" className="label-block">
                            Código de segurança
                        </label>
                        <input
                            type="text"
                            className="field"
                            id="giftCardCode"
                            name="code"
                            placeholder="EX 123*"
                            maxLength="4"
                            value={this.state.formFields.code}
                            onChange={this.handleInputChange}
                        />
                        {this.validator.message('code', this.state.formFields.code, 'required', 'text-danger', { default: 'Preencha o código' })}
                    </div>
                </div>

                <div className="fields-row margin-bottom fields-error">
                    {errorMessage}
                </div>
                
                <div className="fields-row fields-btns">
                    {!isLoading ? (
                        <button
                            name="button"
                            role="button"
                            type="submit"
                            className="field-btn btn btn--green btn--full"
                        >
                            CONSULTAR
                        </button>
                    ) : <Spinner />}
                </div>
            </form>
        )
    }

    renderBalance() {
        return (
            <div className="gift-card-balance-wrapper modal-title">
                <h2>
                    <small>Saldo atual</small>
                    R$ {Helpers.formatMoney(this.state.balance, 2, ",", ".", " ")}
                </h2>
            </div>
        )
    }

    renderSteps() {
        const { step } = this.state;

        switch (step) {
            case 'form':
                return this.renderForm();
            case 'balance': 
                return this.renderBalance();
        }
    }

    render() {
        const { isOpen } = this.props;
        
        return (
            <Modal
                centered={true}
                isOpen={isOpen}
                onClose={this.onClose}
                ref="modalGiftCardBalance"
            >
                <div className="modal-gift-card-wrapper">
                    <span className="boti-close" title="Fechar" onClick={this.onClose}>&times;</span>   

                    <div className="modal-title">
                        <h2>
                            <small>Cartão Presente</small>
                            Consulta de Saldo
                        </h2>
                    </div>

                    {this.renderSteps()}
                </div>
            </Modal>
        )
    }
}

export default withApollo(ModalGiftCardBalance);
